import React from 'react';
import PropTypes from 'prop-types';

import {
  ListItem as MuiListItem,
  withStyles,
} from '@material-ui/core';

const ListItemRaw = React.forwardRef((props, ref) => {
  const { padding, ...other } = props; //eslint-disable-line no-unused-vars
  return <MuiListItem {...other} ref={ref} />;
});
ListItemRaw.displayName = 'ListItemRaw';

ListItemRaw.propTypes = {
  padding: PropTypes.number
}

const ListItem = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: props => {
      const padding = typeof props.padding === 'number' ? props.padding : 2;
      return theme.spacing(padding);
    },

  },
  button: {
    '&:hover': {
      backgroundColor: theme.palette.primary[50],
    }
  },
  selected: {}
}))(ListItemRaw);

export default ListItem;
